// extracted by mini-css-extract-plugin
export default {"editor":"editor_editor__fkr7J","title":"editor_title__c-C2c"};